import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

/** services */
import { initToken } from '../service/api';
import { BrowserView, MobileView } from 'react-device-detect';

// import mobileHero from '../assets/images/landing_mobile.png';
import mobileHero from '../assets/images/landing_desktop.svg';
// import mobileHero from '../assets/images/landing_desktop-2.png';
import desktopHero from '../assets/images/landing_desktop-2.svg';
import useSignupLocalData from '../hooks/SignupLocalDataHook';
import { globalObject } from '../globalVars';

function Home() {
  const history = useHistory();
  const { removeValue } = useSignupLocalData();

  const { token, formData, activeIndexPage, updateContext } = useContext(UserContext);

  useEffect(() => {
    const url = new URL(window.location.href);
    const search = window.location.search;
    const params = new URLSearchParams(search);

    if (params.has('clear_cache')) {
      // Clear local storage
      removeValue();
      localStorage.clear();
      // Remove the 'clear_cache' parameter
      params.delete('clear_cache');
      // Update the URL without reloading the page
      const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
      window.open(`${newUrl}`, '_self');
      window.close();
    } else {
      //check user started siginup the forword to continue.
      if (activeIndexPage) {
        startProcess();
      }
      updateContext({ renderPixel: params.has('src') && params.get('src') == 'mccorkell' });

      if (params.has('first_name') && params.get('first_name') != '') {
        globalObject.firstName = params.get('first_name');
      }
      if (params.has('surname') && params.get('surname') != '') {
        globalObject.lastName = params.get('surname');
      }
      if (params.has('business_name') && params.get('business_name') != '') {
        globalObject.companyName = params.get('business_name');
      }
      if (params.has('email') && params.get('email') != '') {
        globalObject.emailAddress = params.get('email');
      }
      if (params.has('mobile') && params.get('mobile') != '') {
        globalObject.mobileNumber = params.get('mobile');
      }

      let shouldStartProcess = false;
      for (let key in globalObject) {
        if (globalObject[key] && globalObject[key] !== '') {
          shouldStartProcess = true;
          break;
        }
      }
      if (shouldStartProcess) {
        startProcess();
      }
    }
  }, []);

  const startProcess = async () => {
    try {
      // console.log(window.location.search)
      // console.log(history.location.pathname)
      const search = window.location.search;
      const params = new URLSearchParams(search);
      updateContext({ loading: true, error: '' });
      // console.log(params.get('src'))
      const res = await initToken({
        lead_referrer: params.has('src') ? params.get('src') : undefined,
      });
      updateContext({ loading: false });
      if (res && res.data) {
        updateContext({ token: res.data.Token });
        handleRedirect();
        //history.push('/signup');
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleRedirect = () => {
    history.push('/signup');
  };

  return (
    <>
      <Layout>
        <div className="form-layout">
          <div className="home-body-form">
            <div className="static-block-name">
              <p>Account Application</p>
            </div>
            <MobileView className="hero-image">
              <img src={mobileHero} alt="UnLock" />
            </MobileView>
            <BrowserView className="hero-image">
              <img src={desktopHero} alt="UnLock" />
            </BrowserView>
            <p className="home-trade-credit">
              UnLock is a trade credit account – not a credit card.
            </p>
            <p className="home-digital-card">
              Once approved the account is accessed through a digital Mastercard in your mobile wallet.
            </p>
            <p className="list-header" style={{ color: '#FFFFFF' }}>What you’ll need:</p>
            <ul className="home-list" style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    minWidth: '24px',
                    minHeight: '24px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '50%',
                    marginRight: '12px',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.5 7.5L5.5 10.5L11.5 3.5"
                      stroke="#2C6A04"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>an active ACN or ABN</span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    minWidth: '24px',
                    minHeight: '24px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '50%',
                    marginRight: '12px',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.5 7.5L5.5 10.5L11.5 3.5"
                      stroke="#2C6A04"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>to have been trading for at least 12 months</span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    minWidth: '24px',
                    minHeight: '24px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '50%',
                    marginRight: '12px',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.5 7.5L5.5 10.5L11.5 3.5"
                      stroke="#2C6A04"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>no judgment defaults</span>
              </li>
            </ul>
            <div>
              <div className="d-flex bottom-actions align-center custom-button-start">
                <div className="d-flex">
                  <button className="start-btn" onClick={startProcess}>
                    Start your Application
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Home;
